import React, {Component} from 'react';
import { Formik, Form, Field } from 'formik';
import {
    Grid,
    Button,
    Message
} from 'semantic-ui-react';

import FormsInputsText from '../../inputs/text/forms_inputs_text';
import UpdateProfileSchema from './validation';

class FormsUpdateProfile extends Component {
    state = {
        error: false,
        errorMessage: null,
        success: false
    }
    renderFormSubmissionResult() {
        if (this.state.success === true) {
            return (
                <Message positive>
                    <Message.Header>Personal Information Updated Successfully!</Message.Header>
                </Message>
            );
        }
        if (this.state.error === true) {
            return (
                <Message negative>
                    <Message.Header>We're sorry - there was an issue with the change</Message.Header>
                    <p>
                        { this.state.errorMessage }
                    </p>
                </Message>
            );
        }
    }
    render() {
        const {
            name,
            nric
        } = this.props.user;
        return (
            <Formik
                initialValues={{
                    name,
                    nric
                }}
                validateOnChange={false}
                validateOnBlur={false}
                validationSchema={UpdateProfileSchema}
                onSubmit={(values, actions) => {
                    console.log(values, actions);
                    this.props.updateUserProfileInformation({data: values, accessToken: this.props.user.accessToken}, (result, error) => {
                        console.log('done');
                        if (error) {
                            console.log('done-failed');
                            actions.setSubmitting(false);
                            this.setState({error: true, success: false, errorMessage: error.message});
                        }
                        if (result) {
                            console.log('done-success');
                            actions.setSubmitting(false);
                            this.setState({error: false, success: true, errorMessage: null});
                        }
                    });
                }}
                render={({
                    values,
                    errors,
                    status,
                    touched,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    isSubmitting,
                }) => (
                    <Form style={{paddingBottom: 20, paddingTop: 20}}>
                        <Grid columns={2}>
                            <Grid.Column>
                                <Field
                                    name="name"
                                    label="Name"
                                    component={FormsInputsText}
                                    secondaryLabel=""
                                />
                            </Grid.Column>
                            <Grid.Column>
                                <Field
                                    name="nric"
                                    label="NRIC"
                                    component={FormsInputsText}
                                    secondaryLabel=""
                                />
                            </Grid.Column>
                            <Grid.Column width={16}>
                                {this.renderFormSubmissionResult()}
                            </Grid.Column>
                            <Grid.Column width={16}>
                                <Button
                                    loading={isSubmitting}
                                    type="submit"
                                    primary
                                    disabled={isSubmitting}
                                    fluid
                                    size="big"
                                >
                                    Save
                                </Button>
                            </Grid.Column>
                        </Grid>
                    </Form>
                )}
            />
        );
    }
}

export default FormsUpdateProfile;
